import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SessionWarning = ({ isVisible, onExtend, onLogout, timeRemaining = 300 }) => {
  const [countdown, setCountdown] = useState(timeRemaining);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isVisible, onLogout]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg p-6 max-w-md w-full shadow-elevated">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Clock" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              Session Timeout Warning
            </h3>
            <p className="text-sm text-muted-foreground">
              Your session will expire soon
            </p>
          </div>
        </div>

        <div className="bg-warning/5 border border-warning/20 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-between">
            <span className="text-sm text-foreground">Time remaining:</span>
            <span className="text-lg font-mono font-bold text-warning">
              {formatTime(countdown)}
            </span>
          </div>
          <div className="mt-2 w-full bg-muted rounded-full h-2">
            <div 
              className="bg-warning h-2 rounded-full transition-all duration-1000"
              style={{ width: `${(countdown / timeRemaining) * 100}%` }}
            />
          </div>
        </div>

        <div className="flex space-x-3">
          <Button
            variant="outline"
            size="default"
            onClick={onLogout}
            iconName="LogOut"
            iconPosition="left"
            className="flex-1"
          >
            Logout Now
          </Button>
          <Button
            variant="default"
            size="default"
            onClick={onExtend}
            iconName="RefreshCw"
            iconPosition="left"
            className="flex-1"
          >
            Extend Session
          </Button>
        </div>

        <div className="mt-4 text-center">
          <p className="text-xs text-muted-foreground">
            For security, inactive sessions are automatically terminated
          </p>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;